import React from "react"
import { Link } from "gatsby"

type LinkLayoutProps = {
  children: React.ReactNode
}

const LinkLayout: React.FC<LinkLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-background-primary text-foreground-primary">
      <div className="flex-1 px-6 pt-6 md:flex md:items-center md:justify-center">
        {children}
      </div>
      <footer className="py-6 text-center">
        <Link
          to="/"
          className="font-logo text-sm text-foreground-secondary hover:underline"
        >
          Chillburn Recordings
        </Link>
      </footer>
    </div>
  )
}

export default LinkLayout
